import { useCTASettingsModal } from "@circle-react-shared/uikit/TipTapBlockEditor/CTAExtension/CTASettingsModal";
import { useEmbedModal } from "@circle-react-shared/uikit/TipTapBlockEditor/EmbedExtension/EmbedModal";
import { useFileUploadModal } from "@circle-react-shared/uikit/TipTapBlockEditor/FileExtension/FileUploadModal";
import { useGiphyPickerModal } from "@circle-react-shared/uikit/TipTapBlockEditor/GiphyPickerModal";
import { useImagePickerModal } from "@circle-react-shared/uikit/TipTapBlockEditor/ImageExtension/ImageModal";
import { usePollModal } from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal";
import { useCoverImagePickerModal } from "@circle-react/components/QuickPostV3/CoverImagePickerModal";
import { useVoiceMessageModal } from "@circle-react/components/shared/uikit/TipTapBlockEditor/VoiceMessageModal";
import { useVideoClipModal } from "@circle-react/components/shared/VideoClipRecorder/useVideoClipModal";

export const useHasOpenChildEditorModal = (): boolean => {
  const ctaSettingsModal = useCTASettingsModal();
  const coverImagePickerModal = useCoverImagePickerModal();
  const embedModal = useEmbedModal();
  const fileUploadModal = useFileUploadModal();
  const giphyPickerModal = useGiphyPickerModal();
  const imagePickerModal = useImagePickerModal();
  const pollModal = usePollModal();
  const videoClipModal = useVideoClipModal();
  const voiceMessageModal = useVoiceMessageModal();

  return (
    ctaSettingsModal.visible ||
    coverImagePickerModal.visible ||
    embedModal.visible ||
    fileUploadModal.visible ||
    giphyPickerModal.visible ||
    imagePickerModal.visible ||
    pollModal.visible ||
    videoClipModal.visible ||
    voiceMessageModal.visible
  );
};
